import React, { useEffect } from 'react'
import { Row, Col, FormLabel } from 'react-bootstrap';
import { FormField } from 'uiwidgets/FormField';
import {
    containsAlphaNumAndSpaceOnly, isNumeric, containsAlphaNumOnly, containsAlphaNumAndSpaceAndPunctuationOnly
} from "../../util/Validators";
import { arrayRange } from 'util/NumberUtils';

const AmtcaPlayerRecipient = (props) => {

    let { formData, setFormData, formValidityData, setFormValidityData, recipientValidationFunction } = props;

    const currentDate = new Date();
    const endYear = currentDate.getFullYear();
    const startYear = endYear - 24;

    useEffect(() => {
        recipientValidationFunction.current = validateInput;
    }, []);

    const handleChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;
        if (name === 'spcode') {
            setFormData({
                ...formData,
                sponsorshipKey: value,
                sponsorshipAttributes: {
                    ...formData.sponsorshipAttributes,
                    [name]: value
                }
            })

        } else {
            setFormData({
                ...formData,
                sponsorshipAttributes: {
                    ...formData.sponsorshipAttributes,
                    [name]: value
                }
            })
        }


    }
    const handleValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "spcode":
                if (value.trim() === "") {
                    hasError = true
                    error = "Sponsorship Code cannot be empty"
                } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
                    hasError = true
                    error = "Invalid Sponsorship Code. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "firstName":
                if (value.trim() === "") {
                    hasError = true
                    error = "First name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid First Name. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "lastName":
                if (value.trim() === "") {
                    hasError = true
                    error = "Last name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Last Name key. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "nametype":
                if (value.trim() === "") {
                    hasError = true
                    error = "Name Type cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Name Type. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "gender":
                if (value.trim === "") {
                    hasError = true;
                    error = "Gender is required"
                } else if (value !== 'M' && value !== 'F') {
                    hasError = true;
                    error = "Invalid gender"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "grade":
                if (value.trim === "") {
                    hasError = true;
                    error = "Grade is required"
                } else if (!containsAlphaNumOnly(value)) {
                    hasError = true;
                    error = "Grade must be a alpha-numeric"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "health":
                if (value.trim() === "") {
                    hasError = true
                    error = "Health cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Health value. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "day":
                if (value.trim === "") {
                    hasError = true;
                    error = "Day is required"
                } else if (!isNumeric(value)) {
                    hasError = true;
                    error = "Day must be numeric"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "month":
                if (value.trim === "") {
                    hasError = true;
                    error = "Month is required"
                } else if (!isNumeric(value)) {
                    hasError = true;
                    error = "Month must be numeric"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "year":
                if (value.trim === "") {
                    hasError = true;
                    error = "Year is required"
                } else if (!isNumeric(value)) {
                    hasError = true;
                    error = "Year must be numeric"
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "region":
                if (value.trim() === "") {
                    hasError = true
                    error = "Region cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Region. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "country":
                if (value.trim() === "") {
                    hasError = true
                    error = "Country cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Country. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "notes":
                if (value.trim() === "") {
                    hasError = false
                    error = ""
                } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
                    hasError = true
                    error = "Invalid Notes value. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            default:
                break;
        }
        return { hasError, error };
    }

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <FormField name="spcode" label="Sponsorship Code" type="text" value={formData.sponsorshipAttributes.spcode}
                        placeholder="Sponsorship Code" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.spcodeError} valMsg={formValidityData.spcodeErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
                <Col>
                    <FormField name="firstName" label="First Name" type="text" value={formData.sponsorshipAttributes.firstName}
                        placeholder="First Name" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.firstNameError} valMsg={formValidityData.firstNameErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
                <Col>
                    <FormField name="lastName" label="Last Name" type="text" value={formData.sponsorshipAttributes.lastName}
                        placeholder="Last Name" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.lastNameError} valMsg={formValidityData.lastNameErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormField name="gender" label="Gender" type="select" value={formData.sponsorshipAttributes.gender}
                        placeholder="Gender Name" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.genderError} valMsg={formValidityData.genderErrMsg}
                        readOnly={formData.readOnly}>
                        <option value="" key="zeroval"></option>
                        <option value="F" key="F">Female</option>
                        <option value="M" key="M">Male</option>
                    </FormField>
                </Col>
                <Col>
                    <FormField name="grade" label="Grade" type="select" value={formData.sponsorshipAttributes.grade}
                        placeholder="Grade" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.gradeError} valMsg={formValidityData.gradeErrMsg}
                        readOnly={formData.readOnly}>
                        <option value="" key="zeroval"></option>
                        <option value="JK" key="JK">JK</option>
                        <option value="SK" key="SK">SK</option>
                        {arrayRange(1, 12, 1).map((grade, idx) => (
                            <option value={grade} key={idx}>{grade}</option>
                        ))}
                    </FormField>
                </Col>
                <Col>
                    <FormField name="health" label="Health" type="select" value={formData.sponsorshipAttributes.health}
                        placeholder="Health" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.healthError} valMsg={formValidityData.healthErrMsg}
                        readOnly={formData.readOnly}>
                        <option value="" key="zeroval"></option>
                        <option value="Good" key="GOOD">Good</option>
                        <option value="Poor" key="POOR">Poor</option>
                    </FormField>
                </Col>
            </Row>
            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    <FormLabel>Date of Birth</FormLabel>
                    <Row>
                        <Col>
                            <FormField name="day" label="Day" type="select" value={formData.sponsorshipAttributes.day}
                                placeholder="Day" onChange={handleChange} onBlur={handleValidation}
                                valstate={!formValidityData.dayError} valMsg={formValidityData.dayErrMsg}
                                readOnly={formData.readOnly}>
                                <option value="" key="zeroval"></option>
                                {arrayRange(1, 31, 1).map((day, idx) => (
                                    <option value={day} key={idx}>{day}</option>
                                ))}
                            </FormField>
                        </Col>
                        <Col>
                            <FormField name="month" label="month" type="select" value={formData.sponsorshipAttributes.month}
                                placeholder="Month" onChange={handleChange} onBlur={handleValidation}
                                valstate={!formValidityData.monthError} valMsg={formValidityData.monthErrMsg}
                                readOnly={formData.readOnly}>
                                <option value="" key="zeroval"></option>
                                {arrayRange(1, 12, 1).map((month, idx) => (
                                    <option value={month} key={idx}>{month}</option>
                                ))}
                            </FormField>
                        </Col>
                        <Col>
                            <FormField name="year" label="Year" type="select" value={formData.sponsorshipAttributes.year}
                                placeholder="Year" onChange={handleChange} onBlur={handleValidation}
                                valstate={!formValidityData.yearError} valMsg={formValidityData.yearErrMsg}
                                readOnly={formData.readOnly}>
                                <option value="" key="zeroval"></option>
                                {arrayRange(startYear, endYear, 1).map((year, idx) => (
                                    <option value={year} key={idx}>{year}</option>
                                ))}
                            </FormField>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    <FormField name="region" label="Region" type="text" value={formData.sponsorshipAttributes.region}
                        placeholder="Region" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.regionError} valMsg={formValidityData.regionErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
                <Col>
                    <FormField name="country" label="Country" type="text" value={formData.sponsorshipAttributes.country}
                        placeholder="Country" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.countryError} valMsg={formValidityData.countryErrMsg}
                        readOnly={formData.readOnly} />
                </Col>

            </Row>
            <Row>
                <Col>
                    <FormField name="notes" label="Notes" type="textarea" value={formData.sponsorshipAttributes.notes}
                        placeholder="Notes" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.notesError} valMsg={formValidityData.notesErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
            </Row>
        </React.Fragment>


    );
}


export default AmtcaPlayerRecipient